const enTranslation = {
  common: {
    welcome: 'Welcome',
    login: 'Login',
    logout: 'Logout',
    send: 'Send',
    retry: 'Retry',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    language: 'Language',
    newChat: 'New conversation',
    startingNewChat: 'Starting new conversation...',
    searchMessage: 'Thinking and analyzing relevant information...',
    searchMessageTiming: 'Searching through work instructions and knowledge items...',
    tryAgain: 'Try Again',
    back: 'Back',
    goBack: 'Go Back',
    attachDocument: 'Attach document',
    aiDisclaimer: 'Responses are generated by AI. Always verify important information through official sources.',
    copyAnswer: 'Copy answer',
    copyMessage: 'Copy message',
    copied: 'Copied!',
    copyToClipboard: 'Copy to clipboard',
    expand: 'Expand',
    minimize: 'Minimize',
    showMore: 'Show more',
    noInternalKnowledge: 'No internal knowledge found',
    noAdditionalResponse: 'No additional response',
    // Dual answer UX
    swapMessage: 'We found a company-specific answer. The general answer is still available below.',
    toggleShowGeneral: 'Show general answer (ChatGPT)',
    toggleHideGeneral: 'Hide general answer',
    progressExternal: 'Searching with ChatGPT…',
    progressInternal: 'Searching company knowledge…',
    internalError: 'Company knowledge unavailable right now.',
    promoteSecondary: 'Use as main answer',
    compareAnswers: 'Compare answers side-by-side',
    switchBack: 'Switch back',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Internal guidelines',
  },
  knowledge_source: {
    general_info: 'General information',
    internal_guidelines: 'Internal guidelines',
    internet_results: 'Internet search results',
  },
  errors: {
    assistantResponseContentViolation:
      "The assistant's response violates our content policy. Please try again or rephrase your question.",
    userInputContentViolation:
      'Your request contains content that violates our content policy. Please rephrase your question.',
    llmProviderUserInputBlocked:
      "Your message was blocked by the AI provider's content filter. Please rephrase your question.",
    llmProviderBotResponseBlocked:
      "The AI response was blocked by the provider's content filter. Please try again or rephrase your question.",
    llmProviderApiError: 'We are experiencing issues with our AI service. Please try again later.',
    serverError: 'An unexpected server error occurred. Please try again or contact support if the problem persists.',
    agentNotFound: 'The assistant you are looking for does not exist or is no longer available.',
    conversationNotFound: 'The conversation you are looking for does not exist or is no longer available.',
    startViolatedPoliciesList: 'The following policies were violated',
    questionTooLong: {
      title: 'Your question is too long',
      description: 'The maximum length is 30,000 characters.',
    },
    excelNotSupportedYet: {
      title: 'Excel and CSV support coming soon!',
      description:
        "We're working on Excel and CSV file support and it will be available soon. Please use PDF or Word files for now.",
    },
  },
  auth: {
    welcomeTester: 'Welcome colleague',
    welcomeMessage: 'Welcome to Cody!',
    loginWithMicrosoft: 'Login with Microsoft',
    loginInstructions: 'Log in with your Microsoft account to begin.',
  },
  chat: {
    placeholder: 'Ask your question here',
    thinking: 'Thinking...',
    anonymousUser: 'Anonymous',
    howToAskGoodQuestion: 'How to ask a good question?',
    askQuestion: 'Ask your question',
    exampleQuestions: 'Example questions',
    tryAsking: 'Try asking:',
    assistant: 'Cody, your digital Timing assistant',
    welcomeMessage:
      'Hi {{name}}! I am Cody, your digital Timing assistant. I can help you with questions about inflow, retention, and/or outflow from the work instructions and knowledge items. What would you like to know?',
    loading: 'Loading conversation...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    sensitiveInformationWarning: 'Warning: Sensitive topic, additional answer verification required.',
    serverError: 'An unexpected server error occurred. Please try again or contact support if the problem persists.',
    disclaimerText: 'Answers are searched in Sharepoint and generated by AI. Verify sources on important topics.',
  },
  internetSearch: {
    badgeLabel: 'Internet search on',
    badgeTooltip: 'This assistant can use the internet to search',
    inlineWarning:
      'Note: Do not share company-sensitive or personal data. Inputs for internet search may be used by Microsoft for training.',
    dismiss: 'Dismiss',
    modalTitle: 'Be careful with sensitive data',
    modalBody:
      'This assistant uses internet searches. Do not share company-sensitive or personal information. Inputs may be processed by Microsoft and used to train models. Only share what is necessary and follow Timing policies.',
    gotIt: 'Got it',
  },
  agentChat: {
    placeholder: 'Type your question for agent...',
    welcomeMessage: 'Hi, I am your AI agent. How can I help you today?',
    privilegedWelcomeMessage: 'Hi {{userName}}! {{description}}',
    startPrompt: 'Ask a question to get started',
  },
  profile: {
    settings: 'Settings',
    selectLanguage: 'Select your language',
    appearance: 'Appearance',
    darkMode: 'Dark Mode',
    languageChanged: 'Language changed',
    noEmailAvailable: 'No email available',
  },
  sidebar: {
    conversations: 'History',
    assistants: 'Assistants',
    info: 'Info',
    chatHistory: 'Conversational history',
    today: 'Today',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    earlier: 'Earlier',
    conversation: 'Conversation',
    noAssistantsAvailable: 'No assistants available',
    noContent: 'No content',
    noPreviousConversations: 'No previous history found',
    searchConversations: 'Search history...',
    noSearchResults: 'No history matching your search',
    aboutCody: 'Cody, your digital assistant',
    aboutCodyDescription: 'Cody helps you to make your work more fun and easier.',
    dataVisibilityNoticeTitle: 'Data visibility notice',
    dataVisibilityNoticeBody:
      'Dear user, when you activate Cody, the administrators may gain access to the content – including substantive information – that you share. Naturally, colleagues and third parties have no access to the data and questions you submit.',
    bewareDoNotSharePersonalInformation: 'Note: Do not share personal information.',
    codyKnowledge:
      'Cody has knowledge of all Timing information available on TIPP. These are all knowledge items and work instructions about inflow, retention, and outflow.',
    codyGeneralQuestions:
      'Cody can also help you with general questions, that you can ask ChatGPT or find on the internet.',
    noPersonalQuestions: 'Cody cannot answer client or temp worker specific questions.',
    noInTimeQuestions: 'Cody cannot answer questions about information on Intime, such as news items.',
    askClearQuestions: 'Ask a clear question to Cody, so he can help you well.',
    conversationHistory:
      'Cody takes your conversation history into account. So if you want to ask a follow-up question, this is possible',
    startNewConversation:
      "If you are asking a question on a different topic, it is best to click on 'new conversation'",
    seeHowToAsk: 'see: <1>How to ask a good question?</1> for more tips',
    aboutAssistants: 'Assistant',
    whereToFindAssistants: 'Go to the library for an overview of the assistants.',
    favorites: 'Favorites',
    noFavorites: 'No favorites',
    addFavoritesHint: 'Go to the library to add assistants to your favorites.',
    whenToUseAssistants: "Use the 'Guide through Cody' > this helps you determine what Cody can help you with.",
    BewareAssistantsNotAgents:
      'Note: Cody has assistants, not agents. In short: Cody helps you with separate tasks if you ask for them, like summarizing an email. It will not automatically send the email for you.',
    feedback: 'Use the thumbs under the answer to provide feedback on the answer, this helps make Cody smarter!',
    technicalIssuesTitle: 'Technical problems or improvement suggestion?',
    technicalIssueLogIn: "Can't you log in or are you getting an error message?",
    technicalIssueImprovementProposal: 'Do you have a general improvement suggestion for Cody?',
    technicalISsueAssistants:
      'Do you have an improvement suggestion for one of the assistants or do you want to request a new assistant?',
    technicalIssueBeta: 'Please report this in the Beta Testers Cody Teams chat',
    technicalIssueNonBeta: 'Report this by creating a ticket in <1>SSD</1>',
    loadingPrivilegedAgents: 'Loading Cody...',
  },
  feedback: {
    likeAnswer: 'Like answer',
    dislikeAnswer: 'Dislike answer',
    feedbackSent: 'Your feedback has been sent! ✅',
    provideFeedback: 'Provide feedback on the question',
    enterFeedback: 'Enter your feedback here',
    send: 'Send',
    reasons: {
      incorrect: 'Answer is incorrect',
      sourceIncorrect: 'Source is incorrect',
      other: 'Other...',
    },
  },
  instructionModal: {
    title: 'How to ask a good question?',
    example: 'Example',
  },
  instructions: {
    steps: {
      useFullSentences: {
        title: 'Use complete sentences',
        description:
          'Try to use a complete sentence to avoid misunderstandings and get the best possible answer immediately.',
        examples: ['"How to create a rate appointment" instead of "rate appointment".'],
      },
      noSpecificQuestions: {
        title: "Don't ask client/temp worker specific questions",
        description:
          'Cody only has knowledge of TIPP work instructions and knowledge items, not client or temp worker specific information or other information not found on TIPP.',
        examples: [
          'Don\'t ask: "How many vacation days does John Doe have left?", but ask "Where can I see how many vacation days my temp worker has left?"',
        ],
      },
      askOneThingAtATime: {
        title: 'Ask one thing at a time',
        description: 'Ask one question at a time. This helps the chatbot provide targeted and accurate answers.',
        examples: [
          'Don\'t ask "How many hours can a temp worker work per week and when is a shift considered a night shift?", but ask these two questions one by one.',
        ],
      },
    },
    aiAssistant: {
      intro: 'To ask an AI Assistant a good question, be <1>clear, specific, and provide sufficient context</1>.',
      examplesTitle: 'Examples:',
      examples: [
        'Tell the AI what to do: "Summarize this text" or "Write a formal email"',
        'Add relevant information: "Write an email to a client who is late with payment"',
        'Name a style or tone: "Write it friendly but business-like"',
        'Give feedback if the answer is not good: "Make it shorter", "Use less difficult words" or "Adapt it for a young audience"',
      ],
    },
  },
  library: {
    title: 'Assistants Library',
    subtitle:
      'Discover and create custom versions of assistants that combine instructions, extra knowledge, and any combination of skills.',
    searchPlaceholder: 'Search assistants...',
    createAgent: 'Create Assistant',
    createFirstAgent: 'Create your first assistant',
    noAgents: 'No assistants available',
    noSearchResults: 'No assistants matching your search',
    noDescription: 'No description available',
    active: 'Active',
    library: 'Library',
    of: 'of',
    assistants: 'assistants',
    clearFilters: 'Clear filters',
    filtersCleared: 'Filters cleared',
    all: 'All',
    favorites: 'Favorites',
    normal: 'Normal',
    privileged: 'Privileged',
    noTags: 'No tags',
    agentSelected: 'Assistant selected',
    isNowActive: 'is now active',
    select: 'Select',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    moreTags: 'more tags',
    editAgent: 'Edit assistant',
  },
  createAgent: {
    title: 'New Assistant',
    subtitle: 'Create a new AI assistant to help your team',
    saving: 'Saving...',
    saveAgent: 'Save Assistant',
    basicInfo: 'Basic Information',
    classification: 'Classification',
    tagsAndCustomization: 'Tags & Customization',
    icon: 'Icon',
    name: 'Name',
    namePlaceholder: 'Give the assistant a name',
    description: 'Description',
    descriptionPlaceholder: 'Describe what the assistant can do',
    department: 'Department',
    selectDepartment: 'Select a department',
    jobCategory: 'Job Category',
    selectJobCategory: 'Select a job category',
    tags: 'Tags',
    optional: 'optional',
    addNewTag: 'Add a new tag',
    add: 'Add',
    existingTags: 'Existing tags',
    promptTemplate: 'Prompt Template',
    promptTemplatePlaceholder:
      'Define how the assistant should respond... (for example: You are a helpdesk assistant who responds kindly and professionally to questions about...)',
    fillAllRequiredFields: 'Please fill in all required fields',
    agentCreated: 'Assistant created',
    createdSuccessfully: 'was created successfully',
    creationError: 'Creation error',
    creationErrorDescription: 'An error occurred while creating the assistant',
    unsavedChanges: 'Unsaved changes',
    unsavedChangesMessage: 'You have made changes that have not been saved yet. Are you sure you want to go back?',
    manageJobCategories: 'Manage job categories for this department',
    instructions: 'Instructions',
    instructionsDescription: 'Define how your assistant should behave and respond to users',
    instructionsLabel: 'Instructions',
    instructionsPlaceholder: 'You are a helpful assistant that...',
    instructionsHelperText: "Be specific about the assistant's role, tone, and how it should help users",
    instructionsMinLength: 'Instructions must be at least 20 characters',
    tools: 'Tools',
    searchTool: 'Search tool',
    toolsFileSearch: 'File search',
    toolsInternetSearch: 'Internet search',
    toolsHelper: 'Choose whether this assistant can search attached files or the internet.',
    featureRequest: 'Feature request',
    deleteAssistant: 'Delete Assistant',
    tagsHelp: 'Tags help organize and categorize your assistant',
    exampleQuestions: 'Example Questions',
    exampleQuestionsHelp: 'Add example questions that users can click to start a conversation',
  },
  editAgent: {
    title: 'Edit Assistant',
    subtitle: "Modify your AI assistant's settings and behavior",
    updateAgent: 'Update Assistant',
    deleteAgent: 'Delete Assistant',
    updating: 'Updating...',
    deleting: 'Deleting...',
    agentUpdated: 'Assistant Updated',
    updatedSuccessfully: 'has been updated successfully',
    updateError: 'Update Error',
    updateErrorDescription: 'There was an error updating the assistant. Please try again.',
    agentDeleted: 'Assistant Deleted',
    deletedSuccessfully: 'has been deleted successfully',
    deleteError: 'Delete Error',
    deleteErrorDescription: 'There was an error deleting the assistant. Please try again.',
    deleteConfirmTitle: 'Delete Assistant',
    deleteConfirmMessage: 'Are you sure you want to delete this assistant? This action cannot be undone.',
    confirmDelete: 'Yes, Delete',
    loadingAgent: 'Loading assistant details...',
    failedToLoad: 'Failed to load assistant details',
  },
  jobCategory: {
    addNew: 'Add Category',
    name: 'Name',
    nameRequired: 'Category name is required',
    enterName: 'Enter category name...',
    create: 'Create',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    created: 'Category Created',
    createdSuccessfully: 'was created successfully',
    updated: 'Category Updated',
    updatedSuccessfully: 'was updated successfully',
    deleted: 'Category Deleted',
    deletedSuccessfully: 'was deleted successfully',
    creationError: 'Creation Error',
    creationErrorDescription: 'An error occurred while creating the category',
    updateError: 'Update Error',
    updateErrorDescription: 'An error occurred while updating the category',
    deletionError: 'Deletion Error',
    deletionErrorDescription: 'An error occurred while deleting the category',
    deleteError: 'Delete Error',
    deleteErrorDescription: 'An error occurred while deleting the category',
    deleteConfirmTitle: 'Delete Category',
    deleteConfirmMessage: 'Are you sure you want to delete "{{name}}"?',
    deleteWarning: 'This action cannot be undone and may affect existing agents.',
    warning: 'Warning',
    agentsWillLoseCategory: 'agents will lose their category assignment',
  },
  languageNames: {
    en: 'English',
    nl: 'Dutch',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    pl: 'Polish',
  },
  iconSelector: {
    chooseIcon: 'Choose an icon',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'AI assistant for company knowledge from AHV International.',
}

export default { ...enTranslation, ...clientDefaults }
